import React from "react";
import Select from "react-select";
import US_STATES from "../data/usStates";

// Reusable address form section
function AddressSection({
  prefix,
  customerInfo,
  handleCustomerInfoChange,
  isValidAddress,
  showCountryTooltip,
  setShowCountryTooltip,
  showCountryTooltipEnabled = false,
}) {
  return (
    <>
      <label className="block font-semibold mb-1 mt-4">
        Street Address <span className="text-red-500">*</span>
      </label>
      <input
        type="text"
        name={`${prefix}Street`}
        placeholder="Street Address"
        required
        value={customerInfo[`${prefix}Street`]}
        onChange={handleCustomerInfoChange}
        className={`w-full px-4 py-3 rounded-xl border ${
          customerInfo[`${prefix}Street`] &&
          !isValidAddress(customerInfo[`${prefix}Street`])
            ? "border-red-500"
            : "border-gray-300"
        } mb-4`}
      />
      <label className="block font-semibold mb-1">
        Address Line 2
      </label>
      <input
        type="text"
        name={`${prefix}Line2`}
        placeholder="Apt, Suite, Unit (optional)"
        value={customerInfo[`${prefix}Line2`] || ""}
        onChange={handleCustomerInfoChange}
        className="w-full px-4 py-3 rounded-xl border border-gray-300 mb-4"
      />
      {customerInfo[`${prefix}Street`] &&
        !isValidAddress(customerInfo[`${prefix}Street`]) && (
          <p className="text-red-500 text-sm mt-1">
            Please enter a valid street address.
          </p>
        )}
      <label className="block font-semibold mb-1 mt-4">
        City <span className="text-red-500">*</span>
      </label>
      <input
        type="text"
        name={`${prefix}City`}
        placeholder="City"
        required
        value={customerInfo[`${prefix}City`]}
        onChange={handleCustomerInfoChange}
        className="w-full px-4 py-3 rounded-xl border border-gray-300 mb-4"
      />
      <label className="block font-semibold mb-1 mt-4">
        State <span className="text-red-500">*</span>
      </label>
      <Select
        options={US_STATES}
        value={US_STATES.find(
          (s) => s.value === customerInfo[`${prefix}State`]
        )}
        onChange={(option) =>
          handleCustomerInfoChange({
            target: { name: `${prefix}State`, value: option.value },
          })
        }
        className="mb-4"
      />
      <label className="block font-semibold mb-1 mt-4">
        Postal Code <span className="text-red-500">*</span>
      </label>
      <input
        type="text"
        name={`${prefix}Postal`}
        placeholder="Postal Code"
        required
        value={customerInfo[`${prefix}Postal`]}
        onChange={handleCustomerInfoChange}
        className={`w-full px-4 py-3 rounded-xl border ${
          customerInfo[`${prefix}Postal`] &&
          (!/^\d+$/.test(customerInfo[`${prefix}Postal`]) ||
            customerInfo[`${prefix}Postal`].length < 4)
            ? "border-red-500"
            : "border-gray-300"
        } mb-4`}
        inputMode="numeric"
        pattern="\d*"
      />
      {customerInfo[`${prefix}Postal`] &&
        (!/^\d+$/.test(customerInfo[`${prefix}Postal`]) ||
          customerInfo[`${prefix}Postal`].length < 4) && (
          <p className="text-red-500 text-sm mt-1">
            Invalid Postal Code
          </p>
        )}
      <label className="block font-semibold mb-1 mt-4">
        Country <span className="text-red-500">*</span>
      </label>
      {showCountryTooltipEnabled ? (
        <div
          className="relative w-full"
          onMouseEnter={() => setShowCountryTooltip(true)}
          onMouseLeave={() => setShowCountryTooltip(false)}
        >
          <input
            type="text"
            name={`${prefix}Country`}
            placeholder="Country"
            required
            value={customerInfo[`${prefix}Country`]}
            onChange={handleCustomerInfoChange}
            className="w-full px-4 py-3 rounded-xl border border-gray-300 mb-4 bg-gray-200 text-gray-500 cursor-not-allowed"
            disabled
          />
          {showCountryTooltip && (
            <div className="absolute left-1/2 -translate-x-1/2 top-full mt-1 bg-black text-white text-base rounded px-4 py-3 z-50 whitespace-nowrap font-semibold">
              We currently only ship to the United States.
            </div>
          )}
        </div>
      ) : (
        <input
          type="text"
          name={`${prefix}Country`}
          placeholder="Country"
          required
          value={customerInfo[`${prefix}Country`]}
          onChange={handleCustomerInfoChange}
          className="w-full px-4 py-3 rounded-xl border border-gray-300 mb-4 bg-gray-200 text-gray-500 cursor-not-allowed"
          disabled
        />
      )}
    </>
  );
}

const ShippingBillingForm = ({
  customerInfo,
  handleCustomerInfoChange,
  handleBillingCheckboxChange,
  isValidAddress,
  showBilling,
  showCountryTooltip,
  setShowCountryTooltip,
}) => (
  <form className="space-y-4 mb-6">
    <div className="mb-4">
      <h4 className="text-lg font-bold mb-2 text-center">
        Shipping Information
      </h4>
      <AddressSection
        prefix="shipping"
        customerInfo={customerInfo}
        handleCustomerInfoChange={handleCustomerInfoChange}
        isValidAddress={isValidAddress}
        showCountryTooltip={showCountryTooltip}
        setShowCountryTooltip={setShowCountryTooltip}
        showCountryTooltipEnabled={true}
      />
    </div>
    <div className="my-4">
      <label className="flex items-center space-x-2">
        <input
          type="checkbox"
          checked={!showBilling}
          onChange={handleBillingCheckboxChange}
          className="form-checkbox h-5 w-5 text-indigo-600"
        />
        <span className="text-gray-700">
          My billing address is the same as my shipping address
        </span>
      </label>
    </div>
    {showBilling && (
      <div className="mb-6">
        <h4 className="text-lg font-bold mb-2 text-center">
          Billing Information
        </h4>
        <AddressSection
          prefix="billing"
          customerInfo={customerInfo}
          handleCustomerInfoChange={handleCustomerInfoChange}
          isValidAddress={isValidAddress}
          showCountryTooltip={false}
          setShowCountryTooltip={() => {}}
          showCountryTooltipEnabled={false}
        />
      </div>
    )}
  </form>
);

export default ShippingBillingForm;